import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { MasonryBaseComponent } from '../../../abstracts/masonry-base.abstract';
import { environment } from './../../../../environments/environment';
import { BasicInputTypeEnum } from './../../../enums/basic-input-type.enum';

@Component({
    selector: 'app-tax-certificate-form',
    templateUrl: './tax-certificate-form.component.html',
    styleUrls: ['./tax-certificate-form.component.scss'],
})
export class TaxCertificateFormComponent extends MasonryBaseComponent {
    @Input() public control: FormGroup;
    @Output() public elementSizeModification = new EventEmitter<void>();

    public basicInputTypeEnum = BasicInputTypeEnum;
    public environment = environment;

    public get name(): FormControl {
        return this.control.get('name') as FormControl;
    }

    public get quality(): FormControl {
        return this.control.get('quality') as FormControl;
    }

    public get signature(): FormControl {
        return this.control.get('signature_new') as FormControl;
    }

    public get signatureChanged(): FormControl {
        return this.control.get('signature_changed') as FormControl;
    }

    public get signatureUrl(): FormControl {
        return this.control.get('signature_url') as FormControl;
    }

    constructor() {
        super();
    }

    public onImageLoaded(): void {
        setTimeout(() => this.elementSizeModification.emit(), 0);
    }

    public onImageLoadingError(): void {
        setTimeout(() => this.elementSizeModification.emit(), 0);
    }

    public onFileChange(event: any): void {
        const fileUploaded: any = event.target.files[0];
        if (fileUploaded) {
            const reader: FileReader = new FileReader();
            reader.onload = () => {
                this.control.patchValue({
                    signature_new: fileUploaded,
                    signature_url: reader.result,
                    signature_changed: true,
                });
                this.elementSizeModification.emit();
            };
            reader.readAsDataURL(fileUploaded);
        }
    }
}
